import React from 'react';

export interface CefrLevel {
  name: string;
  guidance: string;
}

export interface CefrRegistry {
  version: string;
  last_updated: string;
  render_strategy: string;
  levels: Record<string, CefrLevel>;
}

export function CefrLevelForm({
  levelId,
  level,
  onChange,
  onDelete,
}: {
  levelId: string;
  level: CefrLevel;
  onChange: (updated: CefrLevel) => void;
  onDelete: () => void;
  isNew: boolean;
}) {
  return (
    <div className="bg-white border border-blue-200 rounded-lg p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold text-gray-900">{levelId}</h4>
        <button
          onClick={onDelete}
          className="text-xs text-red-500 hover:text-red-700"
        >
          Delete Level
        </button>
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">Display Name</label>
        <input
          className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          value={level.name}
          onChange={(e) => onChange({ ...level, name: e.target.value })}
        />
      </div>

      <div>
        <label className="block text-xs font-medium text-gray-600 mb-0.5">
          Guidance (injected into prompts as the level-specific block)
        </label>
        <textarea
          className="w-full px-2 py-1.5 text-xs font-mono leading-relaxed border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
          rows={20}
          value={level.guidance}
          onChange={(e) => onChange({ ...level, guidance: e.target.value })}
        />
      </div>
    </div>
  );
}
